const YOUTUBE_VIDEO_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;

const normalizeVideoId = (value: string | null | undefined): string | null =>
  value && YOUTUBE_VIDEO_ID_PATTERN.test(value) ? value : null;

export const getYouTubeVideoId = (url: string): string | null => {
  try {
    const parsedUrl = new URL(url);
    const host = parsedUrl.hostname.replace(/^www\./, '');

    if (host === 'youtu.be') {
      return normalizeVideoId(parsedUrl.pathname.split('/').filter(Boolean)[0]);
    }

    if (
      host === 'youtube.com' ||
      host === 'youtube-nocookie.com' ||
      host === 'm.youtube.com'
    ) {
      if (
        parsedUrl.pathname.startsWith('/embed/') ||
        parsedUrl.pathname.startsWith('/shorts/')
      ) {
        return normalizeVideoId(
          parsedUrl.pathname.split('/').filter(Boolean)[1],
        );
      }

      return normalizeVideoId(parsedUrl.searchParams.get('v'));
    }
  } catch {
    return null;
  }

  return null;
};
